import { EnvironmentOutlined, MailOutlined, PhoneOutlined } from "@ant-design/icons";
import { api } from "@common/api";
import { InputMask } from "@components/atoms/InputMask/InputMask";
import { Button, Form, Input, message, Typography } from "antd";
import { useState } from "react";

const { Title, Paragraph } = Typography;
const { TextArea } = Input;

interface ContactFormValues {
  name: string;
  email: string;
  phone: string;
  subject: string;
  message: string;
}

export const ContactPage = () => {
  const [form] = Form.useForm();
  const [showThankyou, setShowThankyou] = useState(false);
  const [lastSubject, setLastSubject] = useState<string>("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onFinish = async (values: ContactFormValues) => {
    setIsSubmitting(true);
    try {
      const dataToSend = {
        ...values,
        subject: "Request via Landing Page"
      };
      await api.post("/contact", dataToSend);
      setLastSubject("Request via Landing Page");
      setShowThankyou(true);
      message.success("Your message has been sent successfully!");
      form.resetFields();
    } catch (error) {
      console.error("Error sending message:", error);
      message.error("Unable to send your message. Please try again later.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const ThankYouMessage = () => (
    <div className="bg-rock-grey p-6 text-center">
      <div className="mb-6">
        <MailOutlined className="text-primary text-5xl" />
      </div>
      <Title level={3} className="!text-white mb-6">
        THANK YOU FOR REACHING OUT
      </Title>
      <Paragraph className="text-secondary text-lg mb-8">
        Your message regarding "{lastSubject}" has been received. Our team will respond as soon as possible.
      </Paragraph>
      <Button type="primary" onClick={() => setShowThankyou(false)}>
        SEND ANOTHER MESSAGE
      </Button>
    </div>
  );

  return (
    <div
      className="w-full"
      style={{
        backgroundImage: "url('/assets/images/background-darker.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
      }}
    >
      {/* Hero Section */}
      <section className="w-full h-[400px]">
        <div className="container h-full flex flex-col justify-center items-center mx-auto">
          <Title level={1} className="font-azonix !font-normal text-primary tracking-wider text-center">
            CONTACT US
          </Title>
        </div>
      </section>

      {/* Contact Info Section */}
      <section className="w-full bg-black py-16">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-dark flex flex-col items-center p-8 text-center">
              <PhoneOutlined className="text-primary text-3xl mb-4" />
              <Title level={4} className="font-azonix !font-normal text-white">CALL US</Title>
              <Paragraph className="text-secondary text-lg !mb-1">(888) 958-5509</Paragraph>
              <Paragraph className="text-secondary text-sm">Monday - Friday: 7am - 5pm</Paragraph>
            </div>
            <div className="bg-dark flex flex-col items-center p-8 text-center">
              <MailOutlined className="text-primary text-3xl mb-4" />
              <Title level={4} className="font-azonix !font-normal text-white">EMAIL US</Title>
              <Paragraph className="text-secondary text-lg !mb-1">contact@estabrookinc.com</Paragraph>
              <Paragraph className="text-secondary text-sm">We respond within 24h</Paragraph>
            </div>
            <div className="bg-dark flex flex-col items-center p-8 text-center">
              <EnvironmentOutlined className="text-primary text-3xl mb-4" />
              <Title level={4} className="font-azonix !font-normal text-white">MAILING ADDRESS</Title>
              <Paragraph className="text-secondary text-sm">PO Box 1924<br />Truckee, CA 96160</Paragraph>
            </div>
          </div>
        </div>
      </section>

      {/* Form and Map Section */}
      <section className="w-full py-16">
        <div className="container mx-auto px-4">
          <Title level={2} className="font-azonix !font-normal text-primary text-center tracking-wider !mb-8">SEND US A MESSAGE</Title>
          <div className="bg-white w-full md:w-130 mx-auto p-6">
            {!showThankyou ? (
              <Form form={form} layout="vertical" onFinish={onFinish} requiredMark={true} disabled={isSubmitting}>
                <Form.Item label="Full Name" name="name" rules={[{ required: true, message: "Please enter your name" }]}>
                  <div><Input placeholder="Joe Doe" /></div>
                </Form.Item>
                <Form.Item
                  label="Email address"
                  name="email"
                  rules={[
                    { required: true, message: "Please enter your email" },
                    { type: 'email', message: "Please enter a valid email address" }
                  ]}
                >
                  <div><Input placeholder="Email@email.com" /></div>
                </Form.Item>
                <Form.Item label="Phone number" name="phone" rules={[{ required: true, message: "Please enter your phone number" }]}>
                  <InputMask mask="usphone" placeholder="000 000-0000" />
                </Form.Item>
                <Form.Item label="Message" name="message" rules={[{ required: true, message: "Please enter your message" }]}>
                  <div><TextArea rows={4} placeholder="Your message" /></div>
                </Form.Item>
                <div className="text-right"><Button htmlType="submit" loading={isSubmitting} block className="btn-single-cut !w-fit">
                  {isSubmitting ? "SENDING..." : "SEND MESSAGE"}
                </Button></div>
              </Form>
            ) : (
              <ThankYouMessage />
            )}
          </div>
          {/* <Col xs={24} lg={12}>
              <Title level={2} className="font-azonix !font-normal text-primary tracking-wider mb-6">OUR LOCATION</Title>
              <div className="w-full h-[400px] bg-rock-grey overflow-hidden">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3092.3524290317824!2d-120.202587684643!3d39.33233197950668!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x809bd7b0f6e1b6f7%3A0x4a9b6b9b3f3e3e6!2s11168%20W%20River%20St%2C%20Truckee%2C%20CA%2096161%2C%20USA!5e0!3m2!1sen!2sbr!4v1678886400000!5m2!1sen!2sbr"
                  width="100%"
                  height="100%"
                  allowFullScreen={true}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Estabrook Inc. Location"
                ></iframe>
              </div>
              <Paragraph className="text-white text-lg mt-4">
                We're conveniently located to serve the entire Truckee-Tahoe region.
              </Paragraph>
            </Col> */}
        </div>
      </section>
    </div>
  );
};
